import { Ticket } from "../tickets/types";

export type FetchEventParams = {
    eventId: number;
}

export type FetchEventsParams = {
    limit: number;
    offset: number;
}

export type FetchTicketsByEventIdParams = {
    eventId: number;
}

export type ExploreEventsState = {
    // TODO ! ..
    useConstraints: boolean;
    constraints: {
        startDatetime: Date;
        endDatetime: Date;
        eventNameContains: string;
        onlyShowAvailableEvents: boolean;
    },
    // -- 
    events: Map<number, EventDetails>;
    // Event id => Tickets
    ticketsForEvents: Map<number, Ticket[]>;
    loading: boolean; 
    loadingTickets: boolean; 
    error: ExploreEventsError;
    pageSize: number;
    currentPage: number;
}

export enum ExploreEventsError {
    NONE,
    EVENT_FETCH_FAILURE,
    EVENTS_FETCH_FAILURE,
    EVENT_TICKETS_FAILURE,
    LOADING_FAILED,
    ACCESS_BLOCKED,
}

export type EventDetails = {
    id: number;
    title: string;
    description: string;
    startDate: string;
    endDate: string;
    predictedAttendance: number;
    actualAttendance: number;
    onchainSolution: string;
    ticketContractAddress: string;
    ticketCollectionImageUrl?: string;
    tags: string[];
    validTickets?: Ticket[];
    hostMartianName: string;
    hostId: string;
    venueId: number;
    country?: string;
    postcode?: string;
    address_line_1?: string;
    address_line_2?: string;
    address_line_3?: string;
    isFeatured?: boolean;
    price?: number;
    start_date?: string;
};
